import { fetchNetWorthData } from '../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';
import { DEFAULT_PERIOD_ID, VIEWS } from './TransactionsConstants';

export const SET_OR_APPEND_TRANSACTIONS = 'TRANSACTIONS.SET_OR_APPEND_TRANSACTIONS';
export const SUCCESS_ADD_OR_UPDATE_TRANSACTION = 'TRANSACTIONS.SUCCESS_ADD_OR_UPDATE_TRANSACTION';
export const SET_QUERY = 'TRANSACTIONS.SET_QUERY';

export const OPEN_DELETE_MODAL = 'TRANSACTIONS.OPEN_DELETE_MODAL';

export const UPDATE_DRAFT_TRANSACTION = 'TRANSACTIONS.UPDATE_DRAFT_TRANSACTION';

export const SET_ERRORS = 'TRANSACTIONS.SET_ERRORS';
export const CLEAR_ERRORS = 'TRANSACTIONS.CLEAR_ERRORS';

export const SET_DRAFT_TRANSACTION = 'TRANSACTIONS.SET_DRAFT_TRANSACTION';

export const START_DELETE = 'TRANSACTIONS.START_DELETE';
export const SUCCESS_DELETE = 'TRANSACTIONS.SUCCESS_DELETE';
export const FAIL_DELETE = 'TRANSACTIONS.FAIL_DELETE';

export const SET_EXPENSES_CHART_DATA = 'TRANSACTIONS.SET_EXPENSES_CHART_DATA';
export const REMOVE_EXPENSES_CHART_DATA = 'TRANSACTIONS.REMOVE_EXPENSES_CHART_DATA';

export const SET_INCOME_CHART_DATA = 'TRANSACTIONS.SET_INCOME_CHART_DATA';
export const REMOVE_INCOME_CHART_DATA = 'TRANSACTIONS.REMOVE_INCOME_CHART_DATA';

export const SELECT_CATEGORY = 'TRANSACTIONS.SELECT_CATEGORY';
export const SET_CURRENT_VIEW = 'TRANSACTIONS.SET_CURRENT_VIEW';

export const START_UPDATE_TRANSACTION_REQUEST = 'TRANSACTIONS.START_UPDATE_TRANSACTION_REQUEST';
export const END_UPDATE_TRANSACTION_REQUEST = 'TRANSACTIONS.END_UPDATE_TRANSACTION_REQUEST';

export const ON_FILTER_OPEN = 'TRANSACTIONS.ON_FILTER_OPEN';
export const ON_FILTER_CLOSE = 'TRANSACTIONS.ON_FILTER_CLOSE';

export const onFilterOpen = () => ({ type: ON_FILTER_OPEN });
export const onFilterClose = () => ({ type: ON_FILTER_CLOSE });

const setOrAppendTransactions = ({
  transactions,
  accounts,
  expenseCategoryOptions,
  accountId,
  accountName,
  currentPage,
  totalPagesCount,
  periodOptions,
  periodId,
  expenseCategoryFilter,
}) => ({
  type: SET_OR_APPEND_TRANSACTIONS,
  transactions,
  accounts,
  expenseCategoryOptions,
  accountId,
  accountName,
  currentPage,
  totalPagesCount,
  periodOptions,
  periodId,
  expenseCategoryFilter,
});

const addOrUpdateTransaction = transaction => ({
  type: SUCCESS_ADD_OR_UPDATE_TRANSACTION,
  transaction,
});

export const setCurrentView = currentView => ({
  type: SET_CURRENT_VIEW,
  currentView,
});

export const setQuery = query => ({
  type: SET_QUERY,
  query,
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors,
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const setDraftTransaction = transaction => ({
  type: SET_DRAFT_TRANSACTION,
  transaction,
});

export const openAddUpdateModal = () => setCurrentView(VIEWS.EDIT);

export const openDeleteModal = () => ({
  type: OPEN_DELETE_MODAL,
});

export const closeModal = () => setCurrentView(VIEWS.LIST);

export const updateDraftTransaction = data => ({
  type: UPDATE_DRAFT_TRANSACTION,
  data,
});

export const startDeleteRequest = () => ({
  type: START_DELETE,
});

export const successDeleteRequest = id => ({
  type: SUCCESS_DELETE,
  id,
});

export const failDeleteRequest = errors => ({
  type: FAIL_DELETE,
  errors,
});

export const setExpensesChartData = data => ({
  type: SET_EXPENSES_CHART_DATA,
  data,
});

export const removeExpensesChartData = () => ({
  type: REMOVE_EXPENSES_CHART_DATA,
});

export const setIncomeChartData = data => ({
  type: SET_INCOME_CHART_DATA,
  data,
});

export const removeIncomeChartData = () => ({
  type: REMOVE_INCOME_CHART_DATA,
});

export const selectCategory = (categoryName, incomeExpense) => ({
  type: SELECT_CATEGORY,
  categoryName,
  incomeExpense,
});

export const getPersonalFinances = (
  clientId,
  periodId,
  page,
  accountId,
  query,
  category,
  incomeExpense,
  requestOptions = {},
) =>
  ADV.util.request({
    uri: `Consumer/PersonalFinances?clientId=${clientId}&period=${periodId}&page=${page}&accountId=${accountId}&query=${encodeURIComponent(query)}&category=${encodeURIComponent(category)}&incomeExpense=${incomeExpense}`,
    ...requestOptions,
  });

export const fetchTransactions = (
  clientId,
  accountId = '',
  periodId = '',
  query = '',
  category = '',
  page = 1,
  incomeExpense = 0,
) => async (dispatch) => {
  try {
    const { success, errors, payload } = await getPersonalFinances(
      clientId,
      periodId,
      page,
      accountId,
      query,
      category,
      incomeExpense,
    );

    if (success) {
      const {
        AccountName: accountName,
        AccountsList: accounts,
        PeriodOptions: periodOptions,
        TransactionDetails: {
          CurrentPage: currentPage,
          TotalPagesCount: totalPagesCount,
          CashflowCategoryOptions: expenseCategoryOptions,
          Transactions: transactions,
        },
        CashflowCategories,
      } = payload.viewData;

      const normalizedTransactions = transactions.map(transaction => ({
        ...transaction,
        Balance: transaction.NegativeBalance ? -transaction.Balance : transaction.Balance,
      }));

      const normalizedAccounts = accounts.map(({ Id, Name }) => ({ label: Name, value: Id }));

      const normalizedExpenseCategoryOptions = Object.keys(expenseCategoryOptions).map(cat => ({
        label: cat,
        value: cat,
        items: expenseCategoryOptions[cat].map(subcategory => ({
          label: subcategory,
          value: subcategory,
        })),
      }));

      if (CashflowCategories && CashflowCategories.Expenses) {
        dispatch(setExpensesChartData({
          total: CashflowCategories.Expenses.Total,
          series: CashflowCategories.Expenses.Items,
        }));
      } else {
        dispatch(removeExpensesChartData());
      }

      if (CashflowCategories && CashflowCategories.Income) {
        dispatch(setIncomeChartData({
          total: CashflowCategories.Income.Total,
          series: CashflowCategories.Income.Items,
        }));
      } else {
        dispatch(removeIncomeChartData());
      }

      dispatch(setOrAppendTransactions({
        transactions: normalizedTransactions,
        accounts: normalizedAccounts,
        expenseCategoryOptions: normalizedExpenseCategoryOptions,
        accountId,
        accountName,
        currentPage,
        totalPagesCount,
        periodOptions,
        periodId,
        expenseCategoryFilter: category,
      }));
    } else {
      console.error(errors); // eslint-disable-line no-console
    }
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
};

export const updateChartRequest = (
  clientId,
  accountId,
  periodId,
  query,
  category,
  page,
  incomeExpense,
) => dispatch => async (resolve, reject) => {
  try {
    const { success, errors, payload } = await getPersonalFinances(
      clientId,
      periodId,
      page,
      accountId,
      query,
      category,
      incomeExpense,
      { showSpinner: false },
    );

    if (success) {
      const { CashflowCategories } = payload.viewData;

      if (CashflowCategories && CashflowCategories.Expenses) {
        dispatch(setExpensesChartData({
          total: CashflowCategories.Expenses.Total,
          series: CashflowCategories.Expenses.Items,
        }));
      } else {
        dispatch(removeExpensesChartData());
      }

      if (CashflowCategories && CashflowCategories.Income) {
        dispatch(setIncomeChartData({
          total: CashflowCategories.Income.Total,
          series: CashflowCategories.Income.Items,
        }));
      } else {
        dispatch(removeIncomeChartData());
      }

      resolve(true);
    } else {
      dispatch(setErrors(errors));
      console.log('error ', errors); // eslint-disable-line no-console
    }
  } catch (err) {
    reject(err);
    console.error(err); // eslint-disable-line no-console
  }
};

const endUpdateTransaction = payload => ({
  type: END_UPDATE_TRANSACTION_REQUEST,
  payload,
});

export const updateTransaction = (
  clientId,
  transaction,
  accountId,
  periodId,
  query,
  category,
  page,
  incomeExpense,
) => async (dispatch) => {
  dispatch({
    type: START_UPDATE_TRANSACTION_REQUEST,
    payload: transaction,
  });

  try {
    const { success, errors } = await ADV.util.request({
      type: 'POST',
      uri: `Consumer/PersonalFinances/AddOrUpdateTransaction?clientId=${clientId}`,
      data: transaction,
      sendStringifyJSON: true,
      showSpinner: false,
    });

    if (success) {
      try {
        await new Promise((resolve, reject) => {
          dispatch(updateChartRequest(clientId, accountId, periodId, query, category, page, incomeExpense))(resolve, reject);
        });
        dispatch(endUpdateTransaction(transaction));
      } catch (err) {
        dispatch(setErrors(err));
        dispatch(endUpdateTransaction(transaction));
      }
    } else {
      dispatch(setErrors(errors));
      dispatch(endUpdateTransaction(transaction));
      console.error(errors); // eslint-disable-line no-console
    }
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
};

export const saveTransaction = (
  clientId,
  transaction,
  accountId,
  periodId,
  query,
  category,
  page,
) => async (dispatch) => {
  try {
    const { payload, success, errors } = await ADV.util.request({
      type: 'POST',
      uri: `Consumer/PersonalFinances/AddOrUpdateTransaction?clientId=${clientId}`,
      data: transaction,
      sendStringifyJSON: true,
    });

    if (success) {
      const transactionWithId = {
        ...transaction,
        Id: payload.viewData.Id,
      };

      dispatch(addOrUpdateTransaction(transactionWithId));
      dispatch(closeModal());
      dispatch(fetchTransactions(clientId, accountId, periodId, query, category, page));
      dispatch(fetchNetWorthData(clientId));
      dispatch(setCurrentView(VIEWS.LIST));
    } else {
      dispatch(setErrors(errors));
      console.error(errors); // eslint-disable-line no-console
    }
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
};

export const deleteTransaction = (clientId, transactionId) => async (dispatch) => {
  dispatch(startDeleteRequest());

  try {
    const { success, errors } = await ADV.util.request({
      type: 'POST',
      uri: `Consumer/PersonalFinances/DeleteTransaction?clientId=${clientId}&transactionId=${transactionId}`,
    });

    if (success) {
      dispatch(successDeleteRequest(transactionId));
      dispatch(fetchTransactions(clientId, '', DEFAULT_PERIOD_ID));
      dispatch(closeModal());
      dispatch(fetchNetWorthData(clientId));
    } else {
      dispatch(failDeleteRequest(errors));
      console.error(errors); // eslint-disable-line no-console
    }
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
};
